import { render } from "./WrapTableWithShowMore.vue?vue&type=template&id=46ca2328&scoped=true"
import script from "./WrapTableWithShowMore.vue?vue&type=script&lang=js"
export * from "./WrapTableWithShowMore.vue?vue&type=script&lang=js"

import "./WrapTableWithShowMore.vue?vue&type=style&index=0&id=46ca2328&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ca2328"]])

export default __exports__